import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import { TypeAsserter } from '@attain-apps/type-guards'
import gql from 'graphql-tag'

import type * as models from '../../models'
import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.user.DOC}
  query UsersInTenant(
    $tenantId: ID!
    $ids: [ID!]
    $quantity: Int
    $cursor: String
  ) {
    tenant(id: $tenantId) {
      users(ids: $ids, quantity: $quantity, cursor: $cursor) {
        items {
          info {
            ...FragmentUser
          }
          tenantAccess
        }
        nextCursor
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.UsersInTenantQuery,
    ents.core.common.Response.For.Pagination<models.User>,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'users',
      graphql.transformers.OUT.object({
        items: graphql.transformers.OUT.default(
          graphql.transformers.OUT.list(
            graphql.transformers.OUT.custom(user => {
              TypeAsserter.assertIsNotNullish(user?.info)
              return {
                ...fragments.user.TRANSFORMER.getEntityFrom(user.info),
                // TODO: remove id and name transforming when figure out how to
                // handle error that happens when those properties are not
                // handled here
                id: user.info.id ?? undefined,
                name:
                  user.info.firstName && user.info.lastName
                    ? `${user.info.firstName} ${user.info.lastName}`
                    : (user.info.firstName ??
                      user.info.lastName ??
                      'Unknown User'),
                tenantAccess: user?.tenantAccess ?? undefined,
              }
            }),
            { onNullish: 'remove' },
          ),
          [],
        ),
        nextCursor: () => undefined,
      }),
    ),
  ),
  { items: [], nextCursor: undefined },
)

export const execute = graphql.createExecutor<
  graphql.schema.UsersInTenantQuery,
  ents.core.common.Response.For.Pagination<models.User>,
  graphql.schema.UsersInTenantQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
